<template>
	<div class="title">
		<div class="word flex_between" >
			<div class="head_logo flex_between">
				<i class="head_logoT"  @click="homePage"><img src="@/assets/images/logoT.png" alt=""></i>
				<span class="top-font1">{{pageName}}</span>
			</div>
			<div class="more flex_between" v-if="topType === 'usermsg'">
				<span>{{$t('header.user')}}：{{username}}</span>
				<span>{{$t('header.tel')}}：95955</span>
			</div>


			<div v-if="topType === 'line'">
				<span class="line-module" :class="{'thispage' : thisPage === 0}">{{$t('header.Mycart')}}</span>
				<span class="line-module" :class="{'thispage' : thisPage === 1}">{{$t('header.place')}}</span>
				<span class="line-module" :class="{'thispage' : thisPage === 2}">{{$t('header.complete')}}</span>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: "HeaderTitle",
		props: {
			pageName: {
				type: String,
				default: "购物车"
			},
			topType: {
				type: String,
				default: "usermsg"
			}
		},
		data() {
			return {
				thisPage: 0,
				username: ''
			}
		},
		methods:{
			homePage() {
			  this.$router.push("/");
			},
		},
		created() {
			let router_path = this.$route.path;
			if (router_path === '/shopcar') {
				this.thisPage = 0;
			} else if (router_path === '/order' || router_path === '/submit/order') {
				this.thisPage = 1;
			} else {
				this.thisPage = 2;
			}
			this.username = sessionStorage.getItem('user')?JSON.parse(sessionStorage.getItem('user')).surname + JSON.parse(sessionStorage.getItem('user')).name:''
		}
	}
</script>

<style scoped>
	.title {
		width: 100%;
		background: #fff;
		height: 107px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	}

	.head_logoT {
		width: 183px;
		height: 68px;
		margin-right: 21px;
	}

	.top-font1 {
		font-size: 16px;
		color: #333;
		margin-left: 30px;
	}

	.more {
		margin-left: 458px;
		font-size: 13px;
		color: #4A4A4A;
	}

	.more>span {
		padding-right: 10px;
		border-right: 1px solid #E2E2E2;
		margin-right: 10px;
	}

	.more>span:last-child {
		border: 0;
		padding: 0;
		margin: 0;
	}

	.line-module {
		width: 224px;
		height: 37px;
		line-height: 37px;
		text-align: center;
		font-size: 14px;
		display: inline-block;
		background: url('../../assets/images/tbg2.png') center center no-repeat;
		background-size: 100%;
		color: #666666;
	}

	.line-module.thispage {
		background: url('../../assets/images/tbg1.png') center center no-repeat;
		background-size: 100%;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/assembly/HeaderTitle.vue